var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.283,
    y: 0.406,
    width: 22.743,
    height: 3,
    rx: 1.5,
    transform: "rotate(45 2.283 .406)",
    fill: "#956FFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.438,
    y: 16.518,
    width: 22.771,
    height: 3,
    rx: 1.5,
    transform: "rotate(-45 .438 16.518)",
    fill: "#956FFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default "/_next/static/images/8e304e42ff97f2edded40bb2277149dc.svg";
export { ForwardRef as ReactComponent };